import React, { useState, useEffect } from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import {
  Grid,
  Container,
  Box,
  Stack,
  ListItemText,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Menu,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDocsList } from "../../../../redux/docs/index.js";
import HeaderDocs from "./headerDocs/index.js";
import { Folder, FilePresent } from "@mui/icons-material";
import Avatar from "../../../../components/uiElements/avatar/index";
import moment from "moment";
import ResponseAlert from "../../../../components/responseAlert/index.js";
import { deleteFolder } from "../../../../redux/docs/addfolderapi.js";
import { useNavigate, useParams } from "react-router-dom";
import { DataGridPro } from "@mui/x-data-grid-pro";
import AddFolder from "./addFolder/index.jsx";
import TableSkeleton from "../../../../components/loader/tableLoader.jsx";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import renameIcon from "../../../../assets/images/docs/renameIcon.png";
import signatureIcon from "../../../../assets/images/docs/signatureIcon.png";
import mlsIcon from "../../../../assets/images/docs/mlsIcon.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArchiveRoundedIcon from "@mui/icons-material/ArchiveRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import EditMls from "../components/editMls.jsx";
import RenameItem from "../components/rename.jsx";
import { toast } from "react-toastify";
import useDocumentDownloader from "../../../../customHooks/useDocumentDownloader";
import { getDocUrl } from "../../../../redux/docs/getDocUrl";
import InfoDetail from "../components/infoDetail.jsx";

const statusOptions = [
  { value: "active", label: "Active", color: "#009F10" },
  { value: "inactive", label: "Inactive", color: "#E49948" },
  { value: "closed", label: "Closed", color: "#000" },
];

const actionOptions = [
  { value: "rename", label: "Rename", icon: renameIcon, type: "img" },
  { value: "editMls", label: "Edit MLS #", icon: mlsIcon, type: "img" },
  {
    value: "signatureAudit",
    label: "Signature Audit",
    icon: signatureIcon,
    type: "img",
  },
  { value: "copy", label: "Copy", icon: ContentCopyIcon, type: "icon" },
  // { value: "move", label: "Move", icon: OpenWithRoundedIcon, type: "icon" },
  {
    value: "archive",
    label: "Archive",
    icon: ArchiveRoundedIcon,
    type: "icon",
  },
  {
    value: "download",
    label: "Download",
    icon: DownloadRoundedIcon,
    type: "icon",
  },
  { value: "send", label: "Send", icon: SendRoundedIcon, type: "icon" },
  {
    value: "info",
    label: "Info",
    icon: ErrorOutlineOutlinedIcon,
    type: "icon",
  },
];

const FolderListing = ({ classes }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const [docaArray, setDocsArr] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedCheckboxIds, setSelectedCheckboxIds] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [openerror, setOpenerror] = useState(false);
  const [alertType, setAlertType] = useState();
  const [alertMessage, setAlertMesage] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [openMenu, setOpenMenu] = useState(null);
  const [openEditMls, setOpenEditMls] = useState(false);
  const [openRename, setOpenRename] = useState(false);
  const [folderDetails, setFolderDetails] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);

  // downloader hook
  const { downloadDocuments } = useDocumentDownloader();

  const docs = useSelector((item) => item.Docs.docs);
  const agents = useSelector((state) =>
    state.users.storedListOfUsers.list.filter(
      (user) => user.is_agent === true && user.status === "active"
    )
  );

  const columns = [
    {
      field: "name",
      headerName: "Folder Name",
      renderCell: (params) => {
        return (
          <>
            <Grid
              container
              onClick={() => redirectDetails(params.row)}
              className={classes.mAlign}
              alignItems="center"
              xs="auto"
            >
              {params.row.type === "folder" ? (
                <>
                  <Folder sx={{ color: "rgba(0, 0, 0, 0.54)", mr: "15px" }} />
                  <span>{params.row.name}</span>
                </>
              ) : (
                <>
                  <FilePresent
                    sx={{ color: "rgba(0, 0, 0, 0.54)", mr: "15px" }}
                  />
                  <span> {params.row?.forms_data?.name}</span>
                </>
              )}
            </Grid>
          </>
        );
      },
      valueGetter: (params) => {
        return params.row?.forms_data?.name || params.row?.name;
      },
      minWidth: 400,
      flex: 1,
      editable: false,
      sortable: true,
    },
    {
      field: "mls_listing_id",
      headerName: "MLS #",
      renderCell: ({ row }) => {
        // console.log(params);
        return row?.mls_listing_id;
      },
      width: 150,
      editable: false,
      sortable: true,
    },
    {
      field: "first_name",
      headerName: "Owner",
      renderCell: (params) => {
        let agent = agents?.find(
          (item) =>
            item.id === params.row.agent_id ||
            item.id === params.row?.folder_data?.agent_id
        );
        return agent ? (
          <Stack
            onClick={() => redirectDetails(params.row)}
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
          >
            <Avatar
              src={agent?.profile_images?.profile_img}
              sx={{
                width: 26,
                height: 26,
                fontWeight: "400",
              }}
              variant="circular"
            >
              {agent?.first_name?.slice(0, 1)}
            </Avatar>
            <ListItemText
              secondary={`${agent?.first_name} ${agent?.last_name}`}
            />
          </Stack>
        ) : (
          ""
        );
      },
      valueGetter: (params) => {
        const agent = agents?.find(
          (item) =>
            item.id === params.row.agent_id ||
            item.id === params.row?.folder_data?.agent_id
        );
        return agent?.first_name || agent?.last_name;
      },

      width: 250,
      editable: false,
      sortable: true,
    },
    {
      field: "last_updated_at",
      headerName: "Date Modified",
      renderCell: (params) => {
        // console.log(params);
        return (
          <>
            <Grid container onClick={() => redirectDetails(params.row)}>
              {moment(params.row.last_updated_at).format("HH:mm MM-DD-YYYY")}
            </Grid>
          </>
        );
      },
      valueGetter: (params) => new Date(params.row.last_updated_at),
      width: 150,
      editable: false,
      sortable: true,
    },
    {
      field: "status",
      headerName: "Status",
      valueGetter: (params) => {
        return params.row.status || "active";
      },
      renderCell: (params) => {
        return (
          <>
            <Select
              labelId="status-label"
              value={params.row.status || "active"}
              onChange={(e) => {}}
              size="small"
              sx={{ minWidth: 140, height: "35px" }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: option.color,
                        marginRight: 1.5,
                      }}
                    />
                    <Typography>{option.label}</Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </>
        );
      },
      width: 200,
      editable: false,
      sortable: true,
    },
    {
      headerName: "",
      type: "actions",
      renderCell: ({ row }) => {
        // console.log(params);
        return (
          <Box
            onClick={(e) => {
              e.stopPropagation();
              setOpenMenu(e.currentTarget);
              setFolderDetails(row);
            }}
            sx={{ display: "flex", justifyItems: "center" }}
          >
            <IconButton>
              <MoreVertRoundedIcon />
            </IconButton>
          </Box>
        );
      },
      width: 50,
    },
  ];

  const handleOpen = () => {
    setOpen(true);
  };

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    dispatch(getDocsList());
  }, []);

  const redirectDetails = (data) => {
    if (data.type === "folder") {
      navigate(`/docs/folders/${data.id}`, { state: { name: data.name } });
    } else {
      navigate(`/docs/folders/${data.folder_id}/form/${data.id}/edit`);
    }
  };

  const handlePageSizeChange = (params) => {
    setPageSize(params);
  };

  const archiveFunction = () => {
    if (selectedCheckboxIds?.length > 0) {
      Promise.all(
        selectedCheckboxIds?.length &&
          selectedCheckboxIds.map(async (forlderId) => {
            await dispatch(deleteFolder(forlderId));
          })
      ).then(() => {
        setDocsArr([]);
        setOpenerror(true);
        setAlertType("success");
        setAlertMesage("You have successfully Archive the folder");
      });
    } else {
      setOpenerror(true);
      setAlertType("error");
      setAlertMesage("Please select folders or folder");
    }
  };

  const handleDownload = () => {
    if (folderDetails?.id) {
      downloadDocuments([folderDetails?.id], {
        getDocUrlAction: getDocUrl,
      });
    } else {
      toast.error("Please select a folder to download.");
      return;
    }
  };

  return (
    <div className={classes.pageRoot}>
      <HeaderDocs
        addFolderModal={handleOpen}
        selectedCheckboxIds={selectedCheckboxIds}
        archiveFunction={archiveFunction}
        handleSearchInputChange={handleSearchInputChange}
        actionOptions={actionOptions}
        setOpenEditMls={setOpenEditMls}
        setOpenRename={setOpenRename}
        setFolderDetails={setFolderDetails}
        docsData={docs?.data}
        setOpenDetail={setOpenDetail}
      />
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                height: "80vh",
                width: "100%",
                backgroundColor: "white",
                "& .Mui-checked": { color: "#1D1B20 !important" },
              }}
            >
              <DataGridPro
                loading={docs.isLoading}
                components={{
                  LoadingOverlay: TableSkeleton,
                }}
                rows={
                  docs?.data?.length && searchValue
                    ? docs.data.filter((row) =>
                        row.name
                          .toLowerCase()
                          .includes(searchValue.toLowerCase())
                      )
                    : docs?.data?.length
                    ? [...docs?.data]
                    : []
                }
                columns={columns}
                pageSize={pageSize}
                checkboxSelection={true}
                rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
                onRowSelectionModelChange={(itm) => setSelectedCheckboxIds(itm)}
                handlePageSizeChange={handlePageSizeChange}
                disableRowSelectionOnClick
              />
              {/* <AddFolderModal open={open} handleClose={handleClose} modalWidht="auto" agentData={agentData.loading ? [] : agentData.allAgent} /> */}
              <AddFolder open={open} setOpen={setOpen} />

              <ResponseAlert
                setOpen={setOpenerror}
                open={openerror}
                alertType={alertType}
                alertMessage={alertMessage}
              />
              <Menu
                anchorEl={openMenu}
                id="password-dropdown-menu"
                open={Boolean(openMenu)}
                onClose={() => setOpenMenu(false)}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <List sx={{ width: "100%", minWidth: 240 }} disablePadding>
                  {actionOptions?.map((item, index) => {
                    const Icon = item.icon;
                    return (
                      <ListItem
                        onClick={() => {
                          setOpenMenu(false);
                          if (item.label === "Edit MLS #") {
                            setOpenEditMls(true);
                          } else if (item.label === "Rename") {
                            setOpenRename(true);
                          } else if (item.label === "Download") {
                            handleDownload();
                          } else if (item.value === "info") {
                            setOpenDetail(true);
                          }
                        }}
                        key={index}
                        disablePadding
                      >
                        <ListItemButton dense>
                          <ListItemIcon sx={{ minWidth: "40px !important" }}>
                            {item.type === "img" ? (
                              <img
                                style={{ objectFit: "contain" }}
                                src={item.icon}
                                alt={item.label}
                                width={item.label === "Rename" ? 25 : 30}
                                height={item.label === "Rename" ? 25 : 30}
                              />
                            ) : (
                              <Icon
                                sx={{
                                  fontSize: "20px",
                                  transform:
                                    item.label === "info"
                                      ? "rotate(180deg)"
                                      : "",
                                }}
                              />
                            )}
                          </ListItemIcon>
                          <ListItemText primary={item.label} />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              </Menu>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <EditMls
        open={openEditMls}
        setOpen={setOpenEditMls}
        folderDetails={folderDetails}
      />
      <RenameItem
        open={openRename}
        setOpen={setOpenRename}
        folderDetails={folderDetails}
      />
      <InfoDetail
        open={openDetail}
        setOpen={setOpenDetail}
        folderDetails={folderDetails}
      />
    </div>
  );
};

export default withStyles(styleSheet, { name: "FolderStyle" })(FolderListing);
